var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowdownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.6,
    height: 23.6,
    viewBox: "0 0 21.6 23.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DownloadSimple",
    transform: "translate(-5.2 -4.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M10.75,13.75,16,19l5.25-5.25",
    fill: "none",
    stroke: "#324358",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M16,5V19",
    fill: "none",
    stroke: "#324358",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M26,27H6",
    fill: "none",
    stroke: "#324358",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownload);
export default __webpack_public_path__ + "static/media/arrowdownload.517987a5b9229781691c88bda2e6e268.svg";
export { ForwardRef as ReactComponent };